//@flow

import MDEditor from '@uiw/react-md-editor';
import React from 'react';

type Props = {
  value: string,
  className?: string,
};

export default function MarkdownPreview({value, className}: Props) {
  return (
    <div className={className}>
      <MDEditor.Markdown source={value} style={{whiteSpace: 'pre-wrap'}} />
    </div>
  );
}
